import { render, staticRenderFns } from "./AffinityPartnerLogin.vue?vue&type=template&id=c94d1b7a&"
import script from "./AffinityPartnerLogin.vue?vue&type=script&lang=js&"
export * from "./AffinityPartnerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports